

















import { Component, Ref, Vue } from 'vue-property-decorator'

import getSearchDefine from './search'
import getTableDefine from './table'
import getModalDefine from './modal'

import { PagerData } from '@/libs/request/request'
import service, { Village } from '@/api/village/Village'

import IForm from '@/libs/formHelper/form/form.vue'
import IModalForm from '@/libs/formHelper/modalForm/modalForm.vue'
import IPagerTable from '@/libs/tableHelper/pagerTable.vue'

@Component({
  components: {
    IForm,
    IPagerTable,
    IModalForm
  }
})
export default class extends Vue {
  query: any = {
    page: 1,
    pageSize: 10,
    sorts: ['createTime']
  };

  // 表格数据
  tabledata: PagerData<Village> = {
    total: 0,
    items: []
  };

  loading: boolean = true;

  pickerData: any = [];
  pickerSelected: any = [];

  // 表格列定义
  get tableDefine() {
    return getTableDefine(this)
  }

  get searchDefine() {
    return getSearchDefine(this)
  }

  get modalDefine() {
    return getModalDefine(this)
  }

  @Ref('modal')
  modalRef?: IModalForm<Village>;

  created() {
    const data = require('@/config/pca-code.json')
    this.pickerData = data

    this.freshFromServer()
  }

  fetchDataFromServer(
    curPage: number | undefined = undefined,
    pageSize: number | undefined = undefined
  ) {
    if (curPage) {
      this.query.page = curPage
    }
    if (pageSize) {
      this.query.pageSize = pageSize
    }

    let loading = this.$Loading
    loading.start()
    this.loading = true
    service
      .getPagesOfVillage(this.query)
      .then((pagers) => {
        this.tabledata = pagers.result!
      })
      .catch((err) => {
        this.$Message.error(err.message)
      })
      .finally(() => {
        loading.finish()
        this.loading = false
      })
  }

  //  刷新当前页
  freshFromServer(): void {
    this.fetchDataFromServer()
  }

  onSearch() {
    this.fetchDataFromServer(1)
  }

  // 点击创建新的数据
  onNewItem() {
    this.modalRef && this.modalRef.openForNew({})
  }

  // 插入数据
  onInsertItem(dataItem: Village) {
    this.addressHandle(dataItem)
    return service.addOneVillage(dataItem).then(() => {
      this.$Message.success('新增成功')
      this.freshFromServer()
    })
  }

  onViewItem(dataItem: Village) {
    this.addressView(dataItem)
    this.modalRef && this.modalRef.openForView(dataItem)
  }

  // 点击编辑数据
  onEditItem(dataItem: Village) {
    this.addressView(dataItem)
    this.modalRef && this.modalRef.openForModi(dataItem)
  }

  // 更新数据
  onUpdateItem(dataItem: Village) {
    this.addressHandle(dataItem)
    return service.updateOneVillage(dataItem).then(() => {
      this.$Message.success('更新成功')
      this.freshFromServer()
    })
  }

  addressHandle(dataItem: Village) {
    const province = this.pickerData.find(
      (v: any) => v.value === this.pickerSelected[0]
    )
    const city = province.children.find(
      (v: any) => v.value === this.pickerSelected[1]
    )
    const area = city.children.find(
      (v: any) => v.value === this.pickerSelected[2]
    )
    dataItem.province = province.label
    dataItem.city = city.label
    dataItem.area = area.label
  }

  addressView(dataItem: Village) {
    this.pickerSelected = []
    if (dataItem.province) {
      const province = this.pickerData.find(
        (v: any) => v.label === dataItem.province
      )
      if (province) {
        this.pickerSelected.push(province.value)
        if (dataItem.city) {
          const city = province.children.find(
            (v: any) => v.label === dataItem.city
          )
          if (city) {
            this.pickerSelected.push(city.value)
            if (dataItem.area) {
              const area = city.children.find(
                (v: any) => v.label === dataItem.area
              )
              if (area) this.pickerSelected.push(area.value)
            }
          }
        }
      }
    }
  }

  onDelItem(dataItem: Village) {
    return service
      .deleteOneVillage(dataItem.id!)
      .then(() => {
        this.$Message.success('删除成功')
        this.freshFromServer()
      })
      .catch((error) => {
        this.$Message.error(error.message)
      })
  }
}
